import { Component, OnInit, inject, OnDestroy } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd, ActivatedRoute } from '@angular/router';
import { GoogleApiService } from './services/google-api.service';
import { environment } from '@environments/environment';
import { HeaderService } from '@core/services/header.service';
import { OverlayScrollAutocloseService } from '@core/services/overlay-scroll-autoclose.service';
import { AuthStore } from '@features/auth/auth.store';
import { filter, map, mergeMap, Subject, takeUntil } from 'rxjs';
import { ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'admin-app';
  private googleApiService = inject(GoogleApiService);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private headerService = inject(HeaderService);
  private overlayScrollAutocloseService = inject(OverlayScrollAutocloseService);
  private authStore = inject(AuthStore);
  private destroy$ = new Subject<void>();

  ngOnInit() {
    this.overlayScrollAutocloseService.start();

    // Initialize auth store to load data from localStorage
    this.authStore.loadFromStorage();

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let route = this.activatedRoute;
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter(route => route.outlet === 'primary'),
        mergeMap(route => route.data),
        takeUntil(this.destroy$),
      )
      .subscribe(event => {
        if (event['title']) {
          this.headerService.setTitle(event['title']);
        }
      });

    if (environment.googleMapsApiKey) {
      this.googleApiService
        .loadGoogleMapsApi()
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: () => {
            //  todo: use Google API with Proxy
            // Google Maps API loaded successfully
          },
          error: () => {
            // Failed to load Google Maps API
          },
        });
    }
  }

  ngOnDestroy() {
    this.overlayScrollAutocloseService.stop();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
